import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const OutbarainAdHeadline = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12693"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12693)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0664"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0176"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6228"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.145"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.145"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.6047"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.6047"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1531"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8909"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6934 75.0875C54.757 74.9995 54.8881 74.9995 54.9517 75.0875L55.3341 74.8113L54.9517 75.0875L61.9879 84.83C62.064 84.9354 61.9887 85.0826 61.8588 85.0826H47.7863C47.6564 85.0826 47.5811 84.9354 47.6572 84.83L54.6934 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="79.7258"
            y="27.6412"
            width="19"
            height="19"
            rx="9.5"
            fill="url(#pattern0)"
          />
        </g>
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlinkHref="#image0_1529_12693"
              transform="translate(-0.0666667 -0.0682364) scale(0.00287267)"
            />
          </pattern>
          <image
            id="image0_1529_12693"
            width="400"
            height="400"
            xlinkHref="data:image/png;base64,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"
          />
        </defs>
      </SvgIcon>
    );
  })
);
OutbarainAdHeadline.displayName = 'OutbarainAdHeadline';
